import PlayArrowIcon from '@material-ui/icons/PlayArrow';
import PauseIcon from '@material-ui/icons/Pause';
import React from 'react';
import { makeStyles } from '@material-ui/core';


const useStyles = makeStyles(() => {
  return {
    featuredClipControls: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      top: '50%',
      left: '50%',
      position: 'absolute',
      zIndex: 999,
      transform: 'translate(-50%, -50%)',
      borderRadius: '100%',
      height: '50px',
      width: '50px',
      backgroundColor: 'rgba(54, 54, 54, 0.5)',
      border: 'none',
    },
    playBtn: {
      fontSize: '2.5rem',
      color: '#fff',
    },
  };
});


function PlayButton(props) {
  const {
    onTogglePlay,
    isPlaying,
    isFeaturedClip,
  } = props;
  const classes = useStyles();

  if (!isFeaturedClip) {
    return null;
  }

  const PlayIcon = !isPlaying ? PlayArrowIcon : PauseIcon;

  return (
    <button className={classes.featuredClipControls} onClick={onTogglePlay}>
      <PlayIcon className={classes.playBtn} />
    </button>
  );
}

export default PlayButton;
